"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = require("../services");
var setExpirationInLocalStorage = function (name, expireInMinutes) {
    var expirationDate = new Date();
    expirationDate.setMinutes(expirationDate.getMinutes() + expireInMinutes);
    services_1.LocalStorage.setItem(name + "-expiration", expirationDate.toString());
};
exports.default = setExpirationInLocalStorage;
